// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-card {
    border-radius: 10px;
}

.submission-preview-upload-area {
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: 0.15s;
    /*400 px default*/
    position: relative;
}
.hovering-image {
    box-sizing: border-box;
    box-shadow: 0 0 10px 5px var(--primaryColorBright);
}
.upload-input-element {
    height: 100%;
    width: 100%;
    opacity: 0;
    z-index: 5;
    cursor: pointer;
    position: absolute;
}
.submission-preview-img {
    width: auto;
    max-width: 100%;
    max-height: 100%;
    z-index: 1;
}
.submission-preview-img-shadow {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: -1px 1px 2px 0px #00000018;
}

.submission-preview-text {
    font-size: 20px;
    font-weight: 700;
    font-family: Mulish;
    height: 100%;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display:flex;
    align-items: center;
}
.submission-preview-maintext {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    height: -moz-fit-content;
    height: fit-content;
}
.displayName-text {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.username-text {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.amount-text {
    box-sizing:border-box;
    display: flex;
    align-items: last baseline;
    justify-content: space-between;
    gap: 20px;
    font-weight: 900;
    margin:0;
    padding:0;
}

.sp-postText {
    font-size: 16px;
    font-weight: 400;
    font-family: Mulish;
    overflow: auto;
    word-wrap: break-word;
    width: 100%;
}
.sp-postText::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}
.sp-postText::-webkit-scrollbar-track {
    background: #dde;
    border-radius: 1000px;
}
.sp-postText::-webkit-scrollbar-thumb {
    background: var(--primaryColorBright);
    border-radius: 1000px;
}
.sp-postText::-webkit-scrollbar-thumb:hover {
    background: var(--primaryColorDark);
}`, "",{"version":3,"sources":["webpack://./src/styles/general/SubmissionPreviewer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,kDAAkD;AACtD;AACA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,wBAAmB;IAAnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,0BAA0B;IAC1B,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;AACA;IACI,mCAAmC;AACvC","sourcesContent":[".image-card {\n    border-radius: 10px;\n}\n\n.submission-preview-upload-area {\n    width: fit-content;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    transition: 0.15s;\n    /*400 px default*/\n    position: relative;\n}\n.hovering-image {\n    box-sizing: border-box;\n    box-shadow: 0 0 10px 5px var(--primaryColorBright);\n}\n.upload-input-element {\n    height: 100%;\n    width: 100%;\n    opacity: 0;\n    z-index: 5;\n    cursor: pointer;\n    position: absolute;\n}\n.submission-preview-img {\n    width: auto;\n    max-width: 100%;\n    max-height: 100%;\n    z-index: 1;\n}\n.submission-preview-img-shadow {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: -1px 1px 2px 0px #00000018;\n}\n\n.submission-preview-text {\n    font-size: 20px;\n    font-weight: 700;\n    font-family: Mulish;\n    height: 100%;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    display:flex;\n    align-items: center;\n}\n.submission-preview-maintext {\n    width: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    height: fit-content;\n}\n.displayName-text {\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.username-text {\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.amount-text {\n    box-sizing:border-box;\n    display: flex;\n    align-items: last baseline;\n    justify-content: space-between;\n    gap: 20px;\n    font-weight: 900;\n    margin:0;\n    padding:0;\n}\n\n.sp-postText {\n    font-size: 16px;\n    font-weight: 400;\n    font-family: Mulish;\n    overflow: auto;\n    word-wrap: break-word;\n    width: 100%;\n}\n.sp-postText::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n.sp-postText::-webkit-scrollbar-track {\n    background: #dde;\n    border-radius: 1000px;\n}\n.sp-postText::-webkit-scrollbar-thumb {\n    background: var(--primaryColorBright);\n    border-radius: 1000px;\n}\n.sp-postText::-webkit-scrollbar-thumb:hover {\n    background: var(--primaryColorDark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
